import { useQuery } from "@tanstack/react-query";
import { readFaqDetailApi } from "../../../../api/support/faq";

interface ReadFaqDetailProps {
    id: string | null;
}

/**
 * QNA 상세조회 hook
 * @returns
 */
export const useReadFaqDetail2 = (props: ReadFaqDetailProps) => {
    const { id } = props;
    const res = useQuery({
        queryKey: ["readFaqDetailApi2", id],
        queryFn: async (data) => await readFaqDetailApi(id),
        // staleTime: 6000 * 10,
        select: (res) => res?.result.faqDetailRes,
        retry: false,
        enabled: !!props?.id
    });

    return res;
};
